export default __webpack_public_path__ + "static/media/warning.038c56ea.svg";